var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-title"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"split"}),_c('span',{staticClass:"more",on:{"click":_vm.handleMoreClick}},[_vm._v("more")])])}
var staticRenderFns = []

export { render, staticRenderFns }